import React from 'react';
import { useCheckWidth, S33CondensedSpecial, S33CondensedSpecialProps } from '@milanlaser/mlcomponents';
import { type PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';

type S33CondensedSpecialSectionProps = Omit<S33CondensedSpecialProps, 'bannerPosition'> & {
  desktopPaddingTop?: PaddingSize;
  desktopPaddingBottom?: PaddingSize;
  mobilePaddingTop?: PaddingSize;
  mobilePaddingBottom?: PaddingSize;
}

export function S33CondensedSpecialSection(props: S33CondensedSpecialSectionProps) {
  const {
    desktopPaddingTop = 'large',
    desktopPaddingBottom = 'large',
    mobilePaddingTop = 'small',
    mobilePaddingBottom = 'small',
    ...restProps
} = props;
  const { isDesktop } = useCheckWidth();
  const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
  const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;
  
  const childProps = {
    ...restProps,
    bannerPosition: isDesktop === true ? 'right' : 'top',
    badgePosition: isDesktop === true ? 'bottom-right' : 'top-right'
  } as S33CondensedSpecialProps;
  
  return (
    <section className={`${topPaddingClasses} ${bottomPaddingClasses}`}>
      <div className='mcl-px-8 md:mcl-px-6 xl:mcl-px-4'>
        <div className="container">
          <S33CondensedSpecial {...childProps} />
        </div>
      </div>
    </section>
  );
} 